<template>
  <div>
    <Top class="top" />
    <div class="l-container">
      <div class="inner">
        <div class="col_menu">
          <div class="col_menu_head">
            <h3 class="col_menu_text">联系我们</h3>
          </div>
        </div>
        <div class="col_news">
          <div class="col_news_box">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜联系我们</span></span>
                </li>
                <li class="col_title">
                  <h2>联系我们</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con">
              <div class="col_news_list">
                <div class="contact-info">
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="el-icon-office-building"></i>
                    </div>
                    <div class="contact-title">公司名称</div>
                    <div class="contact-value">扬州绿色产业投资发展控股（集团）有限责任公司</div>
                  </div>
                  
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="el-icon-monitor"></i>
                    </div>
                    <div class="contact-title">官方网站</div>
                    <div class="contact-value">
                      <a href="http://www.yzltjt.com" target="_blank">www.yzltjt.com</a>
                    </div>
                  </div>
                  
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="el-icon-phone"></i>
                    </div>
                    <div class="contact-title">联系电话</div>
                    <div class="contact-value">
                      <a href="tel:0514-87863890">0514-87863890</a>
                    </div>
                  </div>
                  
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="el-icon-location"></i>
                    </div>
                    <div class="contact-title">公司地址</div>
                    <div class="contact-value">扬州市江阳中路433号</div>
                  </div>
                  
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="el-icon-message"></i>
                    </div>
                    <div class="contact-title">电子邮箱</div>
                    <div class="contact-value">
                      <a href="mailto:117590570@qq.com">117590570@qq.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterHtm style="margin-top: 10px" />
  </div>
</template>

<script>
import Top from './Top'
import FooterHtm from './FooterHtm'
import 'element-ui/lib/theme-chalk/index.css'

export default {
  name: 'Relation',
  components:{
    Top,
    FooterHtm
  },
  data(){
    let jd = localStorage.getItem('rejd');
    if (jd) {
      // console.log("1")
      if (this.$route.params.num) {
        localStorage.setItem('rejd', this.$route.params.num);
      }
    } else {
      // console.log("2")
      localStorage.setItem('rejd',this.$route.params.num)
    }
    return{
      num:localStorage.getItem('rejd'),
    }
  },
  methods:{
    jump(){
      this.$router.push({
        name:'HelloWorld',
      })
    },
    jumpS(){
      console.log(111)
      this.$router.push({
        name:'Survey',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('jdjd')
    },
    jumpT(){
      this.$router.push({
        name:'State',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('stjd')
    },
    jumpF(){
      this.$router.push({
        name:'Party',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('pajd')
    },
    jumpFI(){
      this.$router.push({
        name:'Culture',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('cujd')
    },
    jumpSI(){
      this.$router.push({
        name:'Relation',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('rejd')
    },
    // tabs(){
    //   trs[i].onmouseover = function() {
    //     this.className = "bg"
    //   }
    //   this.className = "second"
    // }
    // skip(){
    //   console.log(111)
    //   this.$router.push({
    //     name:'Party',
    //   })
    // }
  }
}
</script>

<style scoped>
a{
  color: #000;
  text-decoration: none;
  outline: medium none;
}
.l-container{
  width: 100%;
  min-height: 760px;
  margin: 0 auto;
  background: linear-gradient(rgba(12, 77, 162, 0.02), rgba(12, 77, 162, 0.05));
  padding: 40px 0;
  overflow-x: hidden;
}
.inner{
  padding: 0;
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
  padding: 0 15px;
  box-sizing: border-box;
}
.col_menu{
  width: 280px;
  flex-shrink: 0;
}
.col_menu_head{
  background: linear-gradient(to right, #0a3d82, #1e5dbd);
  border-radius: 8px 8px 0 0;
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.2);
}
.col_menu_text{
  font-size: 24px;
  color: #fff;
  display: block;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  letter-spacing: 2px;
}
.col_news{
  flex: 1;
  min-height: 500px;
}
.col_news_box{
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
.col_news_box:hover {
  transform: translateY(-5px);
}
.col_news_head{
  border-bottom: 1px solid rgba(12, 77, 162, 0.2);
  margin-bottom: 30px;
  padding-bottom: 15px;
  position: relative;
}
.col_news_head::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100px;
  height: 2px;
  background: linear-gradient(to right, #0c4da2, #76b6ff);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}
.col_news_box:hover .col_news_head::after {
  transform: scaleX(1);
}
.col_metas{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}
.col_path{
  color: #666;
  font-size: 14px;
}
.col_path span span {
  color: #0c4da2;
}
.col_title{
  margin: 0;
  color: #0c4da2;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  display: inline-block;
}
.col_title h2{
  margin: 0;
  color: #0c4da2;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  display: inline-block;
}
.col_title h2::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 40px;
  height: 3px;
  background: linear-gradient(to right, #0c4da2, #76b6ff);
  border-radius: 2px;
}
.col_news_con{
  padding: 20px 0;
}
.col_news_list {
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.1);
}
.contact-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 20px;
}
.contact-item {
  padding: 25px;
  background: linear-gradient(145deg, #ffffff, #f5f8ff);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(12, 77, 162, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.contact-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(12, 77, 162, 0.15);
}
.contact-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(to bottom, #0c4da2, #76b6ff);
  border-radius: 2px;
}
.contact-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0c4da2, #1e5dbd);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(12, 77, 162, 0.2);
}
.contact-icon i {
  font-size: 24px;
  color: #fff;
}
.contact-title {
  font-size: 18px;
  font-weight: bold;
  color: #0c4da2;
  margin-bottom: 10px;
}
.contact-value {
  font-size: 16px;
  color: #333;
  line-height: 1.6;
  word-break: break-all;
}
.contact-value a {
  color: #0c4da2;
  text-decoration: none;
  transition: color 0.3s ease;
}
.contact-value a:hover {
  color: #76b6ff;
}

/* 响应式样式 */
@media screen and (max-width: 1200px) {
  .inner {
    max-width: 992px;
    gap: 40px;
  }
  
  .col_news_list {
    padding: 30px;
  }
  
  .contact-info {
    gap: 25px;
  }
}

@media screen and (max-width: 992px) {
  .inner {
    max-width: 768px;
    gap: 30px;
  }
  
  .col_menu {
    width: 220px;
  }
  
  .col_menu_text {
    font-size: 20px;
  }
  
  .col_title h2 {
    font-size: 22px;
  }
  
  .col_news_list {
    padding: 25px;
  }
  
  .contact-info {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }
  
  .contact-item {
    padding: 20px;
  }
}

@media screen and (max-width: 768px) {
  .l-container {
    padding: 20px 0;
    min-height: 500px;
  }
  
  .inner {
    flex-direction: column;
    max-width: 576px;
    gap: 20px;
    padding: 0 15px;
  }
  
  .col_menu {
    width: 100%;
  }
  
  .col_news_box {
    padding: 20px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .col_metas {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .col_path {
    margin-bottom: 10px;
  }
  
  .contact-info {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}

@media screen and (max-width: 576px) {
  .l-container {
    padding: 15px 0;
    min-height: auto;
  }
  
  .inner {
    padding: 0 10px;
  }
  
  .col_menu_text {
    font-size: 18px;
    line-height: 50px;
  }
  
  .col_news_box {
    padding: 15px;
  }
  
  .col_news_list {
    padding: 15px;
  }
  
  .col_title h2 {
    font-size: 20px;
  }
  
  .contact-item {
    padding: 15px;
  }
  
  .contact-icon {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
  }
  
  .contact-icon i {
    font-size: 20px;
  }
  
  .contact-title {
    font-size: 16px;
    margin-bottom: 8px;
  }
  
  .contact-value {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .col_news_head {
    margin-bottom: 20px;
  }
  
  .col_news_list {
    padding: 10px;
  }
  
  .contact-item {
    padding: 12px;
  }
  
  .contact-icon {
    width: 36px;
    height: 36px;
  }
  
  .contact-icon i {
    font-size: 18px;
  }
  
  .contact-title {
    font-size: 15px;
  }
  
  .contact-value {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Relation.vue